"use client";

import { c as _c } from "react/compiler-runtime";
import type { CampaignPageSection } from "@growwithai/shared";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type VideoProps = Extract<CampaignPageSection, {
  type: "video";
}>;

/**
 * Embed video via URL resmi provider (ID sudah divalidasi regex di schema —
 * bukan URL bebas, jadi tidak bisa disalahgunakan untuk iframe arbitrer).
 */
function embedUrl(provider: VideoProps["provider"], videoId: string): string {
  return provider === "youtube" ? `https://www.youtube-nocookie.com/embed/${videoId}` : `https://player.vimeo.com/video/${videoId}`;
}
export default function VideoSection(t0) {
  const $ = _c(17);
  const {
    section
  } = t0;
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style || $[3] !== section.heading) {
    t2 = section.heading && <h2 className="text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={sectionHeadingStyle(section.custom_style)}>{section.heading}</h2>;
    $[2] = section.custom_style;
    $[3] = section.heading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== section.provider || $[6] !== section.video_id) {
    t3 = embedUrl(section.provider, section.video_id);
    $[5] = section.provider;
    $[6] = section.video_id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = section.heading ?? "Video";
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="mt-8 overflow-hidden rounded-2xl border border-black/[0.08] bg-black shadow-xl"><iframe src={t3} title={t4} loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} referrerPolicy="strict-origin-when-cross-origin" className="aspect-video w-full" /></div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t5) {
    t6 = <div className="mx-auto max-w-4xl px-5">{t2}{t5}</div>;
    $[11] = t2;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t1 || $[15] !== t6) {
    t7 = <section className="bg-warm-cream py-14 md:py-20" style={t1}>{t6}</section>;
    $[14] = t1;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}